<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      ><el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_name_cn') || '中文名称'"
            prop="deAttributeName"
          >
            <el-input
              v-model="formData.deAttributeName"
              maxlength="100"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_name_cn') || '中文名称'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '状态'"
            prop="deAttributeStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.deAttributeStatus"
            >
              <el-radio label="Y">{{
                $l("form_radio_valid") || "有效"
              }}</el-radio>
              <el-radio label="N">{{
                $l("form_radio_invalid") || "无效"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_name_en') || '英文名称'"
            prop="deAttributeNameEn"
          >
            <el-input
              v-model="formData.deAttributeNameEn"
              maxlength="100"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_name_en') || '英文名称'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_attribute_type') || '属性类型'"
            prop="deAttributeType"
          >
            <el-input
              v-model="formData.deAttributeType"
              maxlength="50"
              disabled
              clearable
              size="medium"
              :placeholder="$l('form_label_attribute_type') || '属性类型'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_remarks') || '属性说明'"
            prop="deAttributeDescription"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              v-model="formData.deAttributeDescription"
              maxlength="2000"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_remarks') || '属性说明'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col v-if="createDateVisible">
          <div style="font-size: 14px; color: #606266">
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createDate }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    createDateVisible:Boolean,
    deAttributeCode: String,
    deAttributeType: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        deAttributeStatus: "Y",
        deAttributeType:this.deAttributeType,
      },
      rules: {
        deAttributeName: [
          {
            required: true,
            message: this.$l("form_rule_message_name_cn") || "请输入中文名称",
            trigger: "blur",
          },
          {
            max: 100,
            message:
              this.$l("form_rule_input_length_100") || "长度在100个字符以内",
            trigger: "blur",
          },
        ],
        deAttributeNameEn: [
          {
            required: true,
            message: this.$l("form_rule_message_name_en") || "请输入英文名称",
            trigger: "blur",
          },
          {
            max: 100,
            message:
              this.$l("form_rule_input_length_100") || "长度在100个字符以内",
            trigger: "blur",
          },
        ],
        deAttributeType: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_type") || "请输入属性类型",
            trigger: "blur",
          },
          {
            max: 50,
            message:
              this.$l("form_rule_input_length_50") || "长度在50个字符以内",
            trigger: "blur",
          },
        ],
        deAttributeStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.deAttributeCode) return;

      this.$api
        .detailDesignElementsDictionaryApi({
          deAttributeCode: this.deAttributeCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        return;
      }
      this.loadingOpen();
      this.$api
        .saveDesignElementsDictionaryApi(this.formData)
        .then((res) => {
          this.loadingClose();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.openQuestion();
    },
    close() {
      this.$emit("close");
    },
    openQuestion() {
      this.$confirm(
        this.$l("INDEX.tips_question_save") || "是否要保存更改",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l("INDEX.btn_save") || "保存",
          cancelButtonText: this.$l("INDEX.btn_no_save") || "不保存",
        }
      )
        .then(() => {
          this.save();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
  },
};
</script>
